/**
 * Combine composable functions
 * @param functions
 */
export const compose = (...fns: any[]) => {
    return fns.reduceRight(
        (acc, fn) => (data: any) => acc(fn(data)),
        (data: any) => data,
    );
};
